
export default function getPublishStatusAndId( ) {
    const status = localStorage.getItem('publishing')
    const id = localStorage.getItem('publishingId')
    return { status, id }
}
